export default `/* Ids Separator Component */
:host {
  display: block;
}

:host([hidden]) {
  visibility: hidden;
}

:host([vertical]) {
  display: flex;
  height: 100%;
  justify-self: center;
  align-self: stretch;
}

.ids-separator {
  background-color: var(--ids-separator-color-background);
  display: block;
  list-style: none;
}
.ids-separator.appearance-form {
  background-color: var(--ids-separator-color-background-form);
}
.ids-separator:not(.vertical) {
  height: var(--ids-separator-width);
}
.ids-separator:not(.vertical):not(.no-margins) {
  margin-block-start: var(--ids-separator-margin-block-start, var(--ids-separator-margin));
  margin-block-end: var(--ids-separator-margin-block-end, var(--ids-separator-margin));
}
.ids-separator.vertical {
  width: var(--ids-separator-width);
  height: var(--ids-separator-height);
}
.ids-separator.vertical:not(.no-margins) {
  margin-inline-start: var(--ids-separator-margin-inline-start, var(--ids-separator-margin));
  margin-inline-end: var(--ids-separator-margin-inline-end, var(--ids-separator-margin));
}
.ids-separator.color-variant-alternate-formatter.vertical {
  align-self: center;
  background-color: var(--ids-separator-alternate-color-background);
  height: var(--ids-space-sm);
}
.ids-separator.color-variant-module-nav {
  background-color: var(--ids-module-nav-separator-color);
}
.ids-separator.color-variant-module-nav:not(.no-margins) {
  margin-inline: var(--ids-module-nav-separator-expanded-edge-distance);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
